module.exports = __webpack_public_path__ + "static/day21-4949a95df9c2f3e21801788c990966bd.png";